<div class="tab-container h-100">
  <div class="d-flex align-items-center mb-3">
    <button class="btn-custom me-2" (click)="redirectToDashboard()">
      Volver al Dashboard
    </button>
    <span class="fs-4"
      >Formularios de {{ user?.firstName }} {{ user?.lastName }}</span
    >
  </div>

  <ul class="nav nav-underline">
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="activeTab === 'Introduccion'"
        (click)="setActiveTab('Introduccion')"
        >Introducción</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="activeTab === 'Introduccion GYM'"
        (click)="setActiveTab('Introduccion GYM')"
        >Introducción GYM</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="activeTab === 'Chequeos Periodicos'"
        (click)="setActiveTab('Chequeos Periodicos')"
        >Chequeos Periódicos</a
      >
    </li>
  </ul>

  <div class="tab-content mt-3">
    <div
      class="tab-pane fade"
      [class.show]="activeTab === 'Introduccion'"
      [class.active]="activeTab === 'Introduccion'"
    >
      <app-single-forms-answers
        *ngIf="userId"
        [userId]="userId"
        [formType]="'INTRODUCTION'"
      ></app-single-forms-answers>
    </div>
    <div
      class="tab-pane fade"
      [class.show]="activeTab === 'Introduccion GYM'"
      [class.active]="activeTab === 'Introduccion GYM'"
    >
      <app-single-forms-answers
        *ngIf="userId"
        [userId]="userId"
        [formType]="'INTRODUCTION_GYM'"
      ></app-single-forms-answers>
    </div>
    <div
      class="tab-pane fade"
      [class.show]="activeTab === 'Chequeos Periodicos'"
      [class.active]="activeTab === 'Chequeos Periodicos'"
    >
      <app-check-form-answers
        *ngIf="userId"
        [userId]="userId"
      ></app-check-form-answers>
    </div>
  </div>
</div>
